import React, {useCallback, useMemo} from "react";
import {useIntl} from "react-intl";

export default (Wrapped) =>{
    return props =>{
        const {  onClose,repurchaseGiftCardResultCode } = props;
        const intl = useIntl();
        const actualFont = useCallback((size) =>{
            return `${2 * size / 75 * 1}rem`;
        }, []);
        const modalData = useMemo(() =>{
            let modalItem
            if(repurchaseGiftCardResultCode==0){
                modalItem={
                    btn2: {
                        label: intl.formatMessage({ id: "start_shopping_now", defaultMessage: "Start Shopping Now" }),
                        callback: () => {
                            onClose();
                        }
                    },
                    font1: {
                        label: `🎉 Coupon Unlocked!`,
                        style: {
                            fontSize: actualFont(12),
                            fontFamily: 'AppleColorEmoji'
                        }
                    },
                    font2: {
                        label: `50% OFF COUPON`,
                        style: {
                            fontSize: actualFont(20),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:900
                        }
                    },
                    font5: {
                        label: `No minimum required — use it on your next order today!`,
                        style: {
                            fontSize: actualFont(12),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:500
                        }
                    },
                    showTimes: 24*60*60*1000,
                    imageUrl: "/prize/20250714/coupon_2.png"
                }
            }else if(repurchaseGiftCardResultCode==4){
                modalItem={
                    btn2: {
                        label: intl.formatMessage({ id: "ok", defaultMessage: "OK" }),
                        callback: () => {
                            onClose();
                        }
                    },
                    font1: {
                        label: `Oops!`,
                        style: {
                            fontSize: actualFont(15),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:'bold'
                        }
                    },
                    font2: {
                        label: `You have already claimed this coupon.`,
                        style: {
                            fontSize: actualFont(15),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:'bold'
                        }
                    },
                    font4: {
                        label: `Need help? Contact us at:`,
                        style: {
                            fontSize: actualFont(15),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:'bold',
                            color:'#000000'
                        }
                    },
                    font5: {
                        label: `support@chicme.com`,
                        style: {
                            fontSize: actualFont(15),
                            fontFamily: 'Roboto-Medium',
                            fontWeight:'bold',
                            color:'#2F71DE',
                            textDecoration:'underline'
                        }
                    },
                    imageUrl: "/prize/20250714/amazed.png"
                };
            }

            return modalItem;
        },[])
        return <React.Fragment>
            <Wrapped {...props} modalData={modalData}/>
        </React.Fragment>
    }
}